const GENERAL_PRODUCT_INFORMATION_SECTIONS = Object.freeze([
    'identity',
    'purchase-source',
    'supplier-details',
    'complexity',
    'product-weight',
    'material-mixture-categories',
])

const VERTICAL_GENERAL_PRODUCT_INFORMATION_SECTIONS = Object.freeze([
    'identity',
    'purchase-source',
    'supplier-details',
    'complexity',
    'product-weight',
])

export {
    GENERAL_PRODUCT_INFORMATION_SECTIONS,
    VERTICAL_GENERAL_PRODUCT_INFORMATION_SECTIONS,
}
